export default "__VITE_ASSET__CGCWv5Ed__"